"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndicatorFloater = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Hint_1 = require("@jsonjoy.com/ui/lib/1-inline/Hint");
const PositionAtPoint_1 = require("@jsonjoy.com/ui/lib/utils/popup/PositionAtPoint");
const context_1 = require("@jsonjoy.com/ui/lib/context");
const context_2 = require("../context");
const IndicatorFloater = () => {
    const mutxt = (0, context_2.useMuTxt)();
    const state = mutxt.indicator;
    const hidden = (0, context_1.useHiddenTrace)();
    // Re-render on caret/selection changes so the anchor tracks the caret.
    mutxt.version.use();
    const shown = state.shown.use();
    const focused = mutxt.focused.use();
    const readOnly = mutxt.readOnly.use();
    const omniOpen = mutxt.omni.open.use();
    const linkPopupOpen = mutxt.inline.link.open.use();
    if (hidden || !shown || !focused || readOnly || omniOpen || linkPopupOpen)
        return null;
    const point = state.anchorPoint();
    if (!point)
        return null;
    return (React.createElement(PositionAtPoint_1.PositionAtPoint, { point: point },
        React.createElement(Hint_1.Hint, null, shown.content)));
};
exports.IndicatorFloater = IndicatorFloater;
